import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { FileContent } from './file-content';

export class File extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static FileProperties: (
    | {
        property: keyof File;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof File;
        type: 'alias';
      }
    | {
        property: keyof File;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'fileUuid', type: 'column', dataType: 'string' },
    { property: 'filename', type: 'column', dataType: 'string' },
    { property: 'filetype', type: 'column', dataType: 'string' },
    { property: 'filesize', type: 'column', dataType: 'string' },
    { property: 'bucketName', type: 'column', dataType: 'string' },
    { property: 'description', type: 'column', dataType: 'string' },
    { property: 'filepath', type: 'column', dataType: 'string' },
    { property: 'fileLink', type: 'column', dataType: 'string' },
    { property: 'vendorCanView', type: 'column', dataType: 'boolean' },
    { property: 'isArchived', type: 'column', dataType: 'boolean' },
    { property: 'checksum', type: 'column', dataType: 'string' },
    { property: 'FileContentId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'FileContent', model: 'FileContent', type: 'association' }
  ];

  static {
    File.FileProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        File.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        File.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        File.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(FileObject: Partial<File>) {
    super();

    File.FileProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = FileObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  fileUuid?: string | null;
  filename?: string;
  filetype?: string;
  filesize?: number | string;
  description?: string;
  bucketName?: string;
  filepath?: string;
  fileLink?: string;
  vendorCanView?: boolean;
  isArchived?: boolean;
  checksum?: string;
  FileContentId?: number;
  createdAt?: Date;
  updatedAt?: Date;

  FileContent?: FileContent;
}
